<template>
    <a-card size="small" title="短链接业务类型管理">
        <a-button type="primary" slot="extra" @click="handleShow()">新建</a-button>
        <searchE @handleSearch="getAppSumData"></searchE>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData" :scroll="{ x: clientWidth}" :pagination="false" :loading="tloading" rowKey="id">

            <template slot="operation" slot-scope="text, record">
                <a-button type="link" @click="handleQuery(record)">链接查询</a-button>
                <a-button v-if="record.buscode != '00'" type="link" @click="handleShow(record)">编辑</a-button>
                <a-popconfirm v-if="record.buscode != '00'" title="确认删除?" @confirm="() => handleDelete(record)">
                    <a class="tableLink" href="javascript:;">删除</a>
                </a-popconfirm>
            </template>
        </a-table>
        <a-pagination v-model="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" @change="handlePageChange" show-less-items style="float: right; margin-top: 20px" />

        <a-modal :title="modalTitle" :visible="isShow" :confirm-loading="confirmLoading" width="450px" @cancel="handleCancel">
            <a-form-model layout="inline" :model="configItem" ref="ruleForm" :rules="rules">
                <a-form-model-item label="业务类型编码" ref="buscode" prop="buscode">
                    <a-input style="width:400px;" v-if="modalType == 'add'" v-model="configItem.buscode" placeholder="业务类型编码" allow-clear></a-input>
                    <span v-else>{{configItem.buscode}} </span>
                </a-form-model-item>
                <a-form-model-item label="业务类型名称" ref="busname" prop="busname">
                    <a-input style="width:400px;" v-model="configItem.busname" placeholder="业务类型名称" allow-clear></a-input>
                </a-form-model-item>

            </a-form-model>
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    取消
                </a-button>
                <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleSave">
                    确定
                </a-button>
            </template>

        </a-modal>
        <queryE ref="queryE"></queryE>
    </a-card>
</template>
<script>
import searchE from './search'
import queryE from './query'
let pagination = {
    total: 0,
    pageSize: 0,
    page: 1,
}

const columns = [
    {
        title: '序号',
        width: 80,
        align: 'center',
        customRender: (text, record, index) => {
            let { page, pageSize } = pagination
            return (Number(page) - 1) * Number(pageSize) + index + 1
        },
    },
    {
        title: '业务类型编码',
        width: 200,
        dataIndex: 'buscode',
        align: 'center',
        ellipsises: true,
    },
    {
        title: '业务类型名称',
        width: 200,
        dataIndex: 'busname',
        align: 'center',
        ellipsises: true,
    },

    {
        title: '创建时间',
        width: 150,
        dataIndex: 'createtime',
        ellipsis: true,
        align: 'center',
    },

    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 180,
        scopedSlots: { customRender: 'operation' },
    },
]

export default {
    data() {
        return {
            modalTitle: '',
            modalType: '',
            isShow: false,
            confirmLoading: false,
            rules: {
                buscode: [
                    { required: true, message: ' 请输入 ', trigger: 'blur' },
                ],
                busname: [
                    { required: true, message: ' 请输入 ', trigger: 'blur' },
                ],
            },
            configItem: {
                id: '',
                buscode: '',
                busname: '',
            },
            columns,
            tableData: [],
            tloading: false,
            clientWidth: 800,
            searchP: {},
            pagination,
            modalVisible: false,
        }
    },
    methods: {
        handlePageChange(v) {
            this.pagination.page = v
            this.getAppSumData()
        },
        getAppSumData(sp) {
            let that = this
            that.searchP = sp
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams: false,
            }
            that.$store
                .dispatch({
                    type: 'open/shortLinkTypePage',
                    params: params,
                })
                .then((res) => {
                    if (res.status == 200 && res.data.success == '1') {
                        let result = res.data.data
                        that.tableData = result.list
                        that.pagination.total = parseInt(result.totalRecords)
                        that.pagination.pageSize = parseInt(result.pageSize)
                        that.pagination.page = parseInt(result.page)
                    }
                    that.tloading = false
                })
                .catch(() => {
                    that.tloading = false
                })
        },
        handleSave() {
            let that = this
            that.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    that.confirmLoading = true
                    if (that.configItem.id != '') {
                        that.$store
                            .dispatch({
                                type: 'open/shortLinkTypeEdit',
                                params: that.configItem,
                            })
                            .then((response) => {
                                if (response.data.success == '1') {
                                    that.handleCancel()
                                }
                                that.confirmLoading = false
                            })
                    } else {
                        //新增
                        that.$store
                            .dispatch({
                                type: 'open/shortLinkTypeAdd',
                                params: that.configItem,
                            })
                            .then((response) => {
                                if (response.data.success == '1') {
                                    that.handleCancel()
                                }
                                that.confirmLoading = false
                            })
                    }
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        handleShow(record) {
            this.isShow = true
            let that = this
            if (record) {
                that.modalTitle = '编辑短链接业务类型'
                that.modalType = 'edit'
                that.$store
                    .dispatch({
                        type: 'open/shortLinkTypeDetail',
                        params: {
                            ...record,
                        },
                    })
                    .then((response) => {
                        if (response.data.success == '1') {
                            that.configItem = response.data.data
                        }
                    })
            } else {
                this.modalTitle = '新建短链接业务类型'
                that.modalType = 'add'

                this.configItem = {
                    id: '',
                    buscode: '',
                    busname: '',
                }
            }
        },
        handleQuery(record) {
            // let that = this
            // that.$store
            //     .dispatch({
            //         type: 'open/queryShortLink',
            //         params: { buscode: record.buscode, linkid: record.linkid },
            //     })
            //     .then((res) => {
            //         if (res.status == '200') {
            //             console.log(res)
            //         }
            //     })
            this.$refs.queryE.init(record.buscode)
        },
        handleDelete(record) {
            let that = this
            that.$store
                .dispatch({
                    type: 'open/shortLinkTypeDel',
                    params: { buscode: record.buscode },
                })
                .then((res) => {
                    if (res.status == '200') {
                        that.pagination.page = 1
                        that.getAppSumData()
                    }
                })
        },
        handleCancel() {
            this.configItem = {
                buscode: '',
                busname: '',
            }
            this.isShow = false
            this.pagination.page = 1

            this.getAppSumData()
        },
    },
    components: {
        searchE,
        queryE,
    },
}
</script>

<style scoped>
.trend_pagination {
    margin-top: 10px;
}

.tableLink {
    margin-right: 10px;
}
</style>
